import type { EntityGraphNode } from "../../../../core/engine/EntityGraphNode/EntityGraphNode.type"
import type { ForestEntity } from "../../../../core/entity/EntityType/Forest"
import getManhattanDistance from "../../../../core/tile_position_xy/getManhattanDistance"

type ForestCluster = Array<EntityGraphNode<ForestEntity>>
type ForestClusterList = Array<ForestCluster>

// Step 1: Create initial clusters based on adjacency
export default function createInitialForestClusters(
  entities: ForestCluster
): ForestClusterList {
  const visited = new Set<number>()
  const chunks: ForestClusterList = []

  function floodFill(start: EntityGraphNode<ForestEntity>, cluster: ForestCluster) {
    const stack = [start]
    visited.add(start.id)

    while (stack.length > 0) {
      const currentEntNode = stack.pop()!
      const currentEnt = currentEntNode.raw()
      cluster.push(currentEntNode)

      for (const otherEntNode of entities) {
        if (!visited.has(otherEntNode.id) && getManhattanDistance(currentEnt, otherEntNode.raw()) === 1) {
          visited.add(otherEntNode.id)
          stack.push(otherEntNode)
        }
      }
    }
  }

  for (const entityNode of entities) {
    if (!visited.has(entityNode.id)) {
      const cluster: ForestCluster = []
      floodFill(entityNode, cluster)
      chunks.push(cluster)
    }
  }
  return chunks
}